import WarrantyFaultGroupPage from 'pages/WarrantyManagement/WarrantyFaultGroupPage';
import WarrantyPeriodPage from 'pages/WarrantyPeriod/WarrantyPeriodPage';
import WarrantyPeriodAddPage from 'pages/WarrantyPeriod/WarrantyPeriodAddPage';
import WarrantyWorkflowConfigPage from 'pages/WarrantyManagement/WarrantyWorkflowConfigPage';
import WarrantyWorkflowPages from 'pages/WarrantyManagement/WarrantyWorkflowPages';
import WarrantyTypePage from 'pages/WarrantyManagement/WarrantyTypePage';

const warrantyPeriodRoute = [
  { path: '/warranty-locations', exact: true, name: 'Điểm tiếp nhận & xử lý bảo hành', function: 'MD_WARRANTYTYPE_VIEW', component: WarrantyWorkflowConfigPage },
  ...['/warranty-workflows','/warranty-workflow-steps'].flatMap(path=>[
    {path,exact:true,name:path.endsWith('steps')?'Bước công việc bảo hành':'Quy trình bảo hành',function:'MD_WARRANTYTYPE_VIEW',component:WarrantyWorkflowPages},
    {path:`${path}/add`,exact:true,name:path.endsWith('steps')?'Thêm bước công việc':'Thêm quy trình bảo hành',function:'MD_WARRANTYTYPE_ADD',component:WarrantyWorkflowPages},
    {path:`${path}/edit/:id`,exact:true,name:path.endsWith('steps')?'Chỉnh sửa bước công việc':'Chỉnh sửa quy trình bảo hành',function:'MD_WARRANTYTYPE_EDIT',component:WarrantyWorkflowPages},
    {path:`${path}/detail/:id`,exact:true,name:path.endsWith('steps')?'Chi tiết bước công việc':'Chi tiết quy trình bảo hành',function:'MD_WARRANTYTYPE_VIEW',component:WarrantyWorkflowPages},
  ]),
  { path: '/warranty-fault-groups', exact: true, name: 'Nhóm lỗi', function: 'MD_WARRANTYFAULT_VIEW', component: WarrantyFaultGroupPage },
  { path: '/warranty-types', exact: true, name: 'Hình thức bảo hành', function: 'MD_WARRANTYTYPE_VIEW', component: WarrantyTypePage },
  {
    path: '/warranty-period',
    exact: true,
    name: 'Danh mục thời hạn bảo hành',
    function: 'MD_WARRANTYPERIOD_VIEW',
    component: WarrantyPeriodPage,
  },
  {
    path: '/warranty-period/add',
    exact: true,
    name: 'Thêm mới thời hạn bảo hành',
    function: 'MD_WARRANTYPERIOD_ADD',
    component: WarrantyPeriodAddPage,
  },
  {
    path: '/warranty-period/edit/:warranty_period_id',
    exact: true,
    name: 'Chỉnh sửa thời hạn bảo hành',
    function: 'MD_WARRANTYPERIOD_EDIT',
    component: WarrantyPeriodAddPage,
  },
  {
    path: '/warranty-period/detail/:warranty_period_id',
    exact: true,
    name: 'Chi tiết thời hạn bảo hành',
    function: 'MD_WARRANTYPERIOD_VIEW',
    component: WarrantyPeriodAddPage,
  },
];

export default warrantyPeriodRoute;
